// extracted by mini-css-extract-plugin
export default {"legend":"Legend_legend__zgyC2","item":"Legend_item__rzuJz"};